import React from "react";
import { Row, Col, Checkbox } from "antd";

const MultipleChoiceInput: React.FC<any> = ({
  value = undefined,
  placeholder,
  isMulti,
  options,
  onChange,
}) => {
  return (
    <div className="tiles padding-12">
      <span className="col-label">{placeholder}</span>
      <Row className="mt-3 w-100">
        <Col span={24}>
          {isMulti ? (
            <Checkbox.Group
              className="d-flex flex-row align-items-start"
              options={options}
              value={value}
              onChange={(values) => {
                onChange(values);
              }}
            />
          ) : (
            <React.Fragment>
              {options.map((option, index) => (
                <Checkbox
                  className="mb-2 ml-0"
                  checked={option === value}
                  name={option}
                  key={option}
                  onChange={(e) => {
                    onChange(option);
                  }}
                >
                  {option}
                </Checkbox>
              ))}
            </React.Fragment>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MultipleChoiceInput;
